module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/winpe-ignite.json
// module id = 1527
// module chunks = 49975319402768